import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b900af08"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  x: "125",
  y: "95"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M7.7 11.8c-.2 0-.4-.1-.5-.2l-3-3 1.1-1.1 2.3 2.3 4-6.7 1.3.8-4.5 7.6c-.2.2-.4.3-.7.3z",
  fill: "currentColor"
}, null, -1 /* HOISTED */))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["checkbox", { disabled: $props.disabled }]),
    disabled: $props.disabled,
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.emits('update:modelValue', !$props.modelValue)), ["stop","prevent"]))
  }, [
    ($props.modelValue)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4))
      : _createCommentVNode("v-if", true)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}